import CircularDiagram from './CircularDiagram';

export default CircularDiagram;
